export default () => ({
  auth: {
    user: null,
    statusKnown: false,
    error: null
  },
  infuse: {},
  administration: {},
  passthru: {
    messages: []
  },
  snackbar: {
    messages: []
  },
  sso: {
    ssoConfig: null,
    navigatedToSsoPage: false
  },
  tabs: {},
  userEmulation: {
    interceptorsAdded: false,
    isSnackbarVisible: false
  }
});
